import { UserState } from 'types/reducers/user';

export const userInitialState: UserState = {
  userId: '',
  isLoggedIn: false,
  firstName: '',
  lastName: '',
  emailAddr: '',
  userLocation: [],
};
